module.exports = __webpack_public_path__ + "static/plants-5-a6ad64f13c7f2ff74a7d81ecdead0332.jpg";